import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { CommonService } from '../../../../service/common.service';
import { Platform, IonInfiniteScroll,IonSlides } from '@ionic/angular';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { EmitserviceService } from "../../../../service/emitservice.service";
import { BaseCase } from '../../../basecase';
declare var echarts;//设置echarts全局对象
declare var app;

@Component({
  selector: 'app-a2-head-pg',
  templateUrl: './a2-head-pg.component.html',
  styleUrls: ['./a2-head-pg.component.scss']
})
export class A2HeadPgComponent extends GridBaseCase implements AfterViewInit{
  @ViewChild('echartsContent1') container1: ElementRef;//与html中div #container1对应
  @ViewChild('echartsContent2') container2: ElementRef;//与html中div #container2对应
  @ViewChild('echartsContent5') container5: ElementRef;//与html中div #container1对应
  @ViewChild('echartsContent6') container6: ElementRef;//与html中div #container2对应
  @ViewChild('echartsContent7') container7: ElementRef;//与html中div #container2对应
  @ViewChild('echartsContent8') container8: ElementRef;//与html中div #container2对应
  // 无身份判断圈圈
  @ViewChild('echartsContent11') container11: ElementRef;
  @ViewChild('echartsContent12') container12: ElementRef;


  // retail身份  
  // BMS产品供应预估准确率(元
  @ViewChild('echartsContent13') container13: ElementRef;
 
  // 'Non-BMS达成
  @ViewChild('echartsContent14') container14: ElementRef;
  // @ViewChild('echartsContent3') container3: ElementRef;//与html中div #container3对应

  @ViewChild(IonSlides) slides:IonSlides;
  // dataArrayList: Array<any> = [];
  
  slideOpts = {
    startAutoplay:true,
    effect: "flip",  //轮播效果
    initialSlide: 0,
    speed: 2000,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
  };
  
  EChart1: any;
  EChart2: any;
  EChart3: any;
  EChart5: any;
  EChart6: any;
  EChart7: any;
  EChart8: any;
  // 无圈圈显示
  EChart11: any;
  EChart12: any;
  EChart13: any;
  EChart14: any;
  dataList:Array<any> = new Array<any>();
  day:any = {a_Title:"提报天数",a_Num:0};
  day1:any = {};
  day2:any = {};
  day3:any = {};
  day4:number = 0;
   // NTS 显示
   day5:any = {};
   day6: any = {};
   day7: any = {};
   day8: any = {};
   day9: any = {};
   day10: any = {};
  roles:boolean = false;
  isdz:boolean = false;//是否店主
  pgInfo:any = {};//pg上班信息
  summeryKPIRoles:boolean = false;//可查看汇总KPI
  ratailShow:boolean = false; // NTS/retails不同身份显示不同轮播
  ratailShow1:any;

  constructor(
    private http:HttpCustomerService,
    private msg:MessageclientService,
    private activaRouter:ActivatedRoute,
    public com:CommonService,
    public router:Router,
    public emitservice:EmitserviceService,
    public baseService: BaseCase
  ) { super(); 
    
  }

  



  

  LoadData(PageNumber,doRefresh){
    // this.container1.setOption(this.downOption); 
    this.echartBind1(0);
    this.echartBind2(0);
    this.echartBind3(0);
    this.echartBind5(0);
    this.echartBind6(0);
    this.echartBind7(0);
    this.echartBind8(0);
    // 无身份圈圈显示
    this.echartBind11(0);
    this.echartBind12(0);
    this.echartBind13(0);
    this.echartBind14(0);
    
    let accbutype = this.com.GetStorageKey("account");
    console.log("身份显示")
    console.log(accbutype.BuType);
    this.ratailShow1 = accbutype.BuType;


   setTimeout(()=>{
    this.dataBaind();
    const that = this;
    if(that.slides){
      that.slides.startAutoplay();
    }
   },300);
  }

  ngAfterViewInit(){
    const that = this;
    
    // if(that.emitservice.eventEmitClockInOrOut.observers.length < 1){
    //   that.emitservice.eventEmitClockInOrOut.subscribe((data)=>{
    //     if(data && (data == "clockIn" || data == "clockOut")){
    //       that.dataBaind();
    //     }
    //   })
    // }

    that.emitservice.eventEmitClockInOrOut.subscribe((data)=>{
      if(data && (data == "clockIn" || data == "clockOut")){
        that.dataBaind();
      }
    })
    this.echartBind1(0);
    this.echartBind2(0);
    this.echartBind3(0);
    this.echartBind5(0);
    this.echartBind6(0);
    this.echartBind7(0);
    this.echartBind8(0);
    this.echartBind11(0);
    this.echartBind12(0);
    this.echartBind13(0);
    this.echartBind14(0);
    
  }

  echartBind1(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
     
    }
    console.log("显示显示====================================")
    // console.log(that.container1.nativeElement);
    if(typeof(that.container1)=="undefined"){return;}
    let ctelement = that.container1.nativeElement;
   
    if(!refreshData){
      that.EChart1 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v,c) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
                
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart1.setOption(options);
      
    }else{
      let optiondata = that.EChart1.getOption();
          optiondata.series[0].data[0].value = number;
          optiondata.series[0].data[1].value = result;
          that.EChart1.setOption(optiondata);
    }
  }
  echartBind2(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof( that.container2)=="undefined"){return;}
    let ctelement = that.container2.nativeElement;
    if(!refreshData){
      that.EChart2 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart2.setOption(options);
    }else{
      let optiondata = that.EChart2.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart2.setOption(optiondata);
    }
    
  }
  echartBind3(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    // let ctelement = that.container3.nativeElement;
    if(!refreshData){
      // that.EChart3 = echarts.init(ctelement);
      // let options = {
      //   backgroundColor: null,
      //   color: ['#8978c5', '#dbdada'],
      //   series: [{
      //     name: '目标',
      //     type: 'pie',
      //     radius: ['80%', '90%'],
      //     avoidLabelOverlap: false,
      //     hoverAnimation: false,
      //     label: {
      //       normal: {
      //         show: false,
      //         position: 'center',
      //         textStyle: {
      //           fontSize: 16,
      //           color: '#000',
      //           fontWeight: 'bold'
      //         },
      //         formatter: function (v) {
      //           if(that.isdz){
      //             return v.value;
      //           }else{
      //             return v.value+"%";
      //           }
      //         }
      //       }
      //     },
      //     data: [{
      //       value: number,
      //       name: '完成率',
      //       label: {
      //         normal: {
      //           show: true
      //         }
      //       }
      //     },
      //     {
      //       value: result,
      //       name: ''
      //     }
      //     ]
      //   }]
      // };
      // that.EChart3.setOption(options);
    }else{
      // let optiondata = that.EChart3.getOption();
      // optiondata.series[0].data[0].value = number;
      // optiondata.series[0].data[1].value = result;
      // that.EChart3.setOption(optiondata);
    }
  }
  echartBind5(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof(that.container5)=="undefined"){return;}
    let ctelement = that.container5.nativeElement;
    if(!refreshData){
      that.EChart5 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart5.setOption(options);
    }else{
      let optiondata = that.EChart5.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart5.setOption(optiondata);
    }
    
  }
  echartBind6(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof(that.container6)=="undefined"){return;}
    let ctelement = that.container6.nativeElement;
    if(!refreshData){
      that.EChart6 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart6.setOption(options);
    }else{
      let optiondata = that.EChart6.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart6.setOption(optiondata);
    }
    
  }
  echartBind7(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    // number=20
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    console.log("kkechar numnber",number);
    console.log("kkechar numnber result",result);
    
    if(typeof(that.container7)=="undefined"){return;}
    let ctelement = that.container7.nativeElement;
    if(!refreshData){
      that.EChart7 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart7.setOption(options);
    }else{
      let optiondata = that.EChart7.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart7.setOption(optiondata);
    }
    
  }
  echartBind8(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof(that.container8)=="undefined"){return;}
    let ctelement = that.container8.nativeElement;
    if(!refreshData){
      that.EChart8 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart8.setOption(options);
    }else{
      let optiondata = that.EChart8.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart8.setOption(optiondata);
    }
    
  }
  // 无身份圈圈处理
  echartBind11(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof(that.container8)=="undefined"){return;}
    let ctelement = that.container11.nativeElement;
    if(!refreshData){
      that.EChart11 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart11.setOption(options);
    }else{
      let optiondata = that.EChart11.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart11.setOption(optiondata);
    }
    
  }
  echartBind12(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof(that.container8)=="undefined"){return;}
    let ctelement = that.container12.nativeElement;
    if(!refreshData){
      that.EChart12 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart12.setOption(options);
    }else{
      let optiondata = that.EChart12.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart12.setOption(optiondata);
    }
    
  }

  echartBind13(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof(that.container13)=="undefined"){return;}
    let ctelement = that.container13.nativeElement;
    if(!refreshData){
      that.EChart13 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart13.setOption(options);
    }else{
      let optiondata = that.EChart13.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart13.setOption(optiondata);
    }
    
  }
  echartBind14(radio:any,refreshData:boolean = false) {
    const that=this;
    let maxnum = 100;
    let number:number = Number.parseFloat(radio);//当前值
    let result:number = 0;
    // if(this.dataArrayList["today"]){
    //   number = this.dataArrayList["today"].value||0;
    // }
    if(number>maxnum){
      maxnum=number;
    }
    if(maxnum-number>100){
      result=100;
    }else{
      result = maxnum-number;
    }
    if(that.isdz){
      if(number==0){
        result=-1;
      }else{
        result=0;
      }
    }
    if(typeof(that.container14)=="undefined"){return;}
    let ctelement = that.container14.nativeElement;
    if(!refreshData){
      that.EChart14 = echarts.init(ctelement);
      let options = {
        backgroundColor: null,
        color: ['#8978c5', '#dbdada'],
        series: [{
          name: '目标',
          type: 'pie',
          radius: ['80%', '90%'],
          avoidLabelOverlap: false,
          hoverAnimation: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              textStyle: {
                fontSize: 16,
                color: '#000',
                fontWeight: 'bold'
              },
              formatter: function (v) {
                if(that.isdz){
                  return v.value;
                }else{
                  return v.value+"%";
                }
              }
            }
          },
          data: [{
            value: number,
            name: '完成率',
            label: {
              normal: {
                show: true
              }
            }
          },
          {
            value: result,
            name: ''
          }
          ]
        }]
      };
      that.EChart14.setOption(options);
    }else{
      let optiondata = that.EChart14.getOption();
      optiondata.series[0].data[0].value = number;
      optiondata.series[0].data[1].value = result;
      that.EChart14.setOption(optiondata);
    }
    
  }
  onResize() {
    this.EChart1.resize();
    this.EChart2.resize();
    // this.EChart3.resize();
    this.EChart5.resize();
    this.EChart6.resize();
    this.EChart7.resize();
    this.EChart8.resize();
    // 无是圆圈
    this.EChart11.resize();
    this.EChart12.resize();
    this.EChart13.resize();
    this.EChart14.resize();



    
  }
  dataBaind(){
    const that = this;
    // console.log("2019");
    console.log(that.config,"Log");
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body: WebParameterContext = new WebParameterContext();
    console.log("ididiidididiidi")
    console.log(body);
    body.Account = that.com.GetAccount;
    if (that.config[0].selectItemList && that.config[0].selectItemList.gridViewConfigName) {
      body.ConfigName = that.config[0].selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.Name = pageName;
    let isaccount:boolean = false;
    if(that.com.GetAccount.Roles){
      that.com.GetAccount.Roles.forEach(role=>{
        if(role.Code=="1003" || role.Code=="1004" || role.Code =="1006"){
          if(role.Code=="1006"){
           that.isdz=true;
          }
          if(role.Code == '1003' || role.Code == "1004"){
            that.summeryKPIRoles = true;
          }
          isaccount=true;
        }
        if(role.Code == "1002"){
          that.roles = true;
          const _info = that.com.GetStorageKey("pginfo");
          console.log("显示显示显示显示心事")
          console.log(_info);
          console.log(_info.a_FK_Store_ID);
          if(_info){
            if(_info["a_StartDate"]){
              _info["a_StartDate"] = _info["a_StartDate"].replace(/-/g,"/");
              // const _sDate = new Date(_info["a_StartDate"]);
              // const StartDate = _sDate.getHours() +":"+_sDate.getMinutes() + ":" + _sDate.getSeconds();
              // _info["StartDate"] = StartDate;
            }
            if(_info["a_EndDate"]){
              _info["a_EndDate"] = _info["a_EndDate"].replace(/-/g,"/");
              // const _eDate = new Date(_info["a_StartDate"]);
              // const EndDate = _eDate.getHours() +":"+_eDate.getMinutes() + ":" + _eDate.getSeconds();
              // _info["EndDate"] = EndDate; 
            }
            that.pgInfo = _info;
            // that.pgInfo["storeName"] = _info["c_Name"] || null;
            // if(!_info["a_StartDate"] && !_info["a_EndDate"]){
            //   that.pgInfo["workStatus"] = "未上班";
            // }else if(_info["a_StartDate"] && !_info["a_EndDate"]){
            //   that.pgInfo["workStatus"] = "已上班";
            // }else if(_info["a_StartDate"] && _info["a_EndDate"]){
            //   that.pgInfo["workStatus"] = "已下班";
            // }
          }
        }
      });
    }
    // console.log("cewjekwjkgbwjkkgkwbgkrbw")
    // console.log(that.com.GetAccount);
    // console.log(that.com.GetAccount.Id);
    // let infoArry = that.com.GetStorageKey("pginfo");
    // let idArry = [that.com.GetAccount.Id, infoArry.a_FK_Store_ID]; // 参数id和门店id
    let idArry:Array<any>=new Array<any>();
    idArry.push(that.com.GetAccount.Id);
    let infoArry = that.com.GetStorageKey("pginfo")||{};
    if(infoArry.a_FK_Store_ID){
      idArry.push(infoArry.a_FK_Store_ID);
    }
    
    if(isaccount)
    {
      body.ConfigName="V_TargetStore";
      body.RequestBody=JSON.stringify({"b_FK_SystemUser_ID":that.com.GetAccount.Id,"a_Year":that.com.getNow.split("-")[0],"a_Month":that.com.getNow.split("-")[1]})
    }else{
      // body.RequestBody = {"a"}
      
      body.RequestBody=JSON.stringify({"a_ID":idArry,"a_Year":that.com.getNow.split("-")[0],"a_Month":that.com.getNow.split("-")[1]});
      // body.RequestBody=JSON.stringify({"a_ID":idArry,"a_Year":that.com.getNow.split("-")[0],"a_Month":"07"})
    }
    console.log("body.RequestBodybody.RequestBodybody.RequestBody")
    console.log(body.RequestBody);
    that.dataList=[];
    that.http.post(app.DEFAULTURL, body).then(data => {
     console.log(body);
    //  console.log()
      if (data.ResponseMessage.Success) {
      console.log("1001010110");
        that.dataList=data.Status.Datas;
        let numday:number = 0;
        let numday1:number = 0;//新客
        let numday2:number = 0;//销量（元）
        let numday3:number = 0;////出勤天数从
        
        let numday5:number = 0; // 新的妈妈新客(人)  
        let numday6: number = 0; //忠实会员 (人)
        let numday7:number  = 0; // BMS库存预测准确率(罐)
        let numday8: number = 0; // 2004 Non-BMS达成(罐)
        let numday11:number  = 0; // BMS库存预测准确率(罐)
        let numday12: number = 0; 
        // 
        let arrayList:Array<any>=new Array<any>();
        let isarray:boolean = false;
        that.dataList.forEach(item=>{
          isarray=false;
          if(arrayList.length<=0){
            arrayList.push(item);
          }else{
            arrayList.forEach(newitem=>{
              if(newitem.a_Code==item.a_Code){
                isarray=true;
                newitem.a_SumPrice+=item.a_SumPrice;
                newitem.a_Volume+=item.a_Volume;
              }
            });
            if(!isarray){
              arrayList.push(item);
            }
          }
        });
        console.log(arrayList,"log");
        arrayList.forEach(item=>{
          // let num:number = Number.parseInt(item.a_Volume);
        
          // let num2:number = Number.parseInt(item.a_SumPrice);
          let num:number = Number.parseFloat(item.a_Volume || 0) ;
          let num2:number = Number.parseFloat(item.a_SumPrice || 0);
          let num4:number = 0;
          if(num==0){//如果分母为零分子不为零则为100%;
            if(num2){
              num4=0;
            }else{
              num4 = 0;
            }
          }else{
            num4 =(num2/num)*100;
          }
          let num3:any = num4.toFixed(2);
          if(item.a_Code=="1004"){//提报天数
            that.day = item;
          }
          if(item.a_Code=="1003"){//出勤天数
            that.day1 = item;
            numday3+=Number.parseFloat(num3);
            // this.echartBind3(num3);
          }
          if(item.a_Code=="2006"){//新客
            that.day2 = item;
            numday1+=Number.parseFloat(num3);
            // this.echartBind1(num3);
          }
          if(item.a_Code=="2005"){//销量（元）
            that.day3 = item;5
            numday2+=Number.parseFloat(num3);
            // this.echartBind2(num3);
          }
          if(item.a_Code == "2001"){
            that.day5 = item;
            numday5+=Number.parseFloat(num3);
          }
          if(item.a_Code == "2002"){
            that.day6 = item;
            numday6+=Number.parseFloat(num3);
          }
          if(item.a_Code == "2003"){
            that.day7 = item;
            numday7+=Number.parseFloat(num3);
            console.log(numday7,"显示的数据书怒++++++++++++++++++")
            
          }
          if(item.a_Code == "2004"){
            that.day8 = item;
            numday8+=Number.parseFloat(num3);
          }
        });
        // console.log("num++++");
        if(that.isdz){
          this.echartBind1(that.day2.a_Num);
          this.echartBind2(that.day3.a_Num);
          this.echartBind3(that.day1.a_Num);
          this.echartBind5(that.day5.a_Num);
          this.echartBind6(that.day6.a_Num);
          this.echartBind7(that.day7.a_Num);
          this.echartBind8(that.day8.a_Num);
          this.echartBind11(0);
          this.echartBind12(0);
          this.echartBind13(that.day7.a_Num);
          this.echartBind14(that.day8.a_Num);
          // this.echartBind5(that.day2.a_Num);
          // this.echartBind6(that.day3.a_Num);
        }else{
          this.echartBind1(numday1);
          this.echartBind2(numday2);
          this.echartBind3(numday3);
          this.echartBind5(numday5);
          this.echartBind6(numday6);
          this.echartBind7(numday7);
          this.echartBind8(numday8);
          this.echartBind11(numday11);
          this.echartBind12(numday12);
          this.echartBind13(numday7);
          this.echartBind14(numday8);
          // this.echartBind5(numday2,true);
          // this.echartBind6(numday3,true);
          // this.echartBind7(numday7,true);
          // this.echartBind3(numday8,true);

        }
        
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
        // console.log(data.ResponseMessage.ErrorMessage);
      }
      if(that.dataList.length<=0){
      //   this.echartBind1(0,true);
      //  this.echartBind2(0,true);
      //  this.echartBind3(0,true);
      }
  }).catch(error => {
       
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
      // this.echartBind1(0,);
      // this.echartBind2(0);
      // this.echartBind3(0);
  });
  }
  /**
   * 跳转页面
   * @param code 
   */
  EventClick(code){
    let url = "/tabs/contact/SalesReport/view/";
    if(this.roles){
      this.com.setHistoryUrl();
      // this.router.navigate([url+"&"+this.com.getNowDatetime]);
      this.com.Go(url+"&"+this.com.getNowDatetime)
    } else if(this.summeryKPIRoles){
      this.com.setHistoryUrl();
      // this.router.navigate(["/tabs/contact/SalesSummaryKPI/view/&"+this.com.getNowDatetime]);
      this.com.Go("/tabs/contact/SalesSummaryKPI/view/&"+this.com.getNowDatetime);
    }
    // if(code == '1001'){
    //   url = "/tabs/contact/mykpiList1/edite/";
    // }else if(code == '1002'){
    // }else if(code == '1003'){
    //   url = "/tabs/contact/mykpiList2/edite/";
    // }
    // this.router.navigate([url+code+"&"+this.com.getNowDatetime]);
  }
}
